<template>
  <div class="main">
    <div class="numerical">
      <div class="numerical-column">
        <span class="title">&nbsp;</span>
        <span class="today">今日</span>
        <span class="yesterday">昨日</span>
      </div>
      <div :class="{'actived': actived === 1}" @click="setActivedColumn(1)" class="numerical-column">
        <span class="title">用户总数</span>
        <span class="today">{{ userTotal.today }}</span>
        <span class="yesterday">{{ userTotal.yesterday }}</span>
      </div>
      <div :class="{'actived': actived === 2}" @click="setActivedColumn(2)" class="numerical-column">
        <span class="title">新用户数</span>
        <span class="today">{{ newUserTotal.today }}</span>
        <span class="yesterday">{{ newUserTotal.yesterday }}</span>
      </div>
      <div :class="{'actived': actived === 3}" @click="setActivedColumn(3)" class="numerical-column">
        <span class="title">新增检测总数</span>
        <span class="today">{{ newCheckTotal.today }}</span>
        <span class="yesterday">{{ newCheckTotal.yesterday }}</span>
      </div>
      <div :class="{'actived': actived === 4}" @click="setActivedColumn(4)" class="numerical-column">
        <span class="title">报告查看次数</span>
        <span class="today">{{ viewReportTotal.today }}</span>
        <span class="yesterday">{{ viewReportTotal.yesterday }}</span>
      </div>
      <div class="big-screen">
          <div class="big-screen-content" @click="GotoBigScreen">       
            <img class="bs-icon" src="~@/assets/images/bs.png"/>
            <span>数据大屏</span>
          </div>
      </div>
    </div>
    <div class="graph">
      <div class="title">
        <span v-if="actived === 1">今日用户年龄性别分布</span>
        <span v-if="actived === 2">今日新用户年龄性别分布</span>
        <template v-if="actived === 3">
          <span>新增检测类型分布（{{ today }}）</span>
          <span>新增检测用户性别分布（{{ today }}）</span>
        </template>
        <span v-if="actived === 4">报告查看性别与时间分布（{{ yesterday }}）</span>
      </div>
      <div class="content">
        <template v-if="actived !== 4">
          <div id="pie" key="pie" v-if="ageVal > 0"></div>
          <div class="no-dots" v-if="ageVal === 0">暂无数据</div>
          <div class="dotted" v-if="(Number(male)+Number(female)) > 0">
            <div class="icon">
              <i class="el-icon-user-solid blue"></i>
            </div>
            <div class="dotted-content">
              <div class="dotted-title">性别分布</div>
              <div class="title">
                <span class="blue">{{ male }}%</span>
                <span class="red">{{ female }}%</span>
              </div>
              <div class="dots">
                <span :key="i" class="dot male" v-for="i in male"></span>
                <span :key="i + male" class="dot female" v-for="i in female"></span>
              </div>              
            </div>
            <div class="icon">
              <i class="el-icon-user-solid red"></i>
            </div>
          </div>
          <div class="dots no-dots" v-if="Number(male) === 0 && Number(female) === 0">暂无数据</div>
        </template>
        <div id="bar" key="bar" v-else></div>
      </div>
    </div>
    <div class="polyline">
      <div class="polyline-hd">
        <div>
          <span class="polyline-title">{{ polylineTitle }}趋势图</span>
          <span class="polyline-subtitle ml-sm">单位（{{ polylineUnit }}）</span>
        </div>
        <div>
          <el-button :type="currentDays === 7 ? 'primary' : ''" @click="currentDays = 7" >最近7天</el-button>
          <el-button :type="currentDays === 30 ? 'primary' : ''" @click="currentDays = 30" >最近30天</el-button>
          <el-button :type="currentDays === 60 ? 'primary' : ''" @click="currentDays = 60" >最近60天</el-button>
        </div>
      </div>
      <!-- 折线图 -->
      <div id="polyline"></div>
    </div>
  </div>
</template>
<script>
import GraphService from "@/model/graph";
import DashboardService from "@/model/api/dashboard";

export default {
  name: "dashboard",
  data() {
    return {
      actived: 0,
      currentDays: 7,
      polylineTitle: "",
      polylineUnit: "",
      today: "2019-6-1",
      yesterday:'',
      genderDistribution: "",
      male: 0,
      female: 0,
      ageVal: 0,
      interval: undefined,
      dialogVisible: false,
      initPwdForm: {},
      isFirstLogin: true,
      userTotal: {
        today: 0,
        yesterday: 0,
        sex: [0, 100]
      },
      newUserTotal: {
        today: 0,
        yesterday: 0,
        sex: [0, 100]
      },
      newCheckTotal: {
        today: 0,
        yesterday: 0,
        sex: [0, 100]
      },
      viewReportTotal: {
        today: 0,
        yesterday: 0
      }
    };
  },
  watch: {
    actived(number) {
      // this.currentDays = 7
      if (number === 1) {
        this.polylineTitle = "用户总数";
        this.polylineUnit = "人";
      }
      if (number === 2) {
        this.polylineTitle = "新用户";
        this.polylineUnit = "人";
      }
      if (number === 3) {
        this.polylineTitle = "新增检测总数";
        this.polylineUnit = "条";
      }
      if (number === 4) {
        this.polylineTitle = "报告查看次数";
        this.polylineUnit = "次";
      }
    },
    currentDays() {
      this.getLineData().then(data => {
        this.drawPolyline(data);
      });
    },
  },
  methods: {
      // 跳转大屏
      GotoBigScreen() {
          let routeUrl = this.$router.resolve({
              name: '大屏预览'
          });
          window.open(routeUrl.href, '_blank');
      },
    // 切换 Tab
    setActivedColumn(number) {
      this.actived = number;
      if (number === 1) {
        this.renderUserData();
      }
      if (number === 2) {
        this.renderNewUserData();
      }
      if (number === 3) {
        this.renderNewCheckData();
      }
      if (number === 4) {
        this.renderReportViewData();
      }
    },

    // 获取并渲染用户数据
    renderUserData() {
      this.getUserData().then(res => {
          console.log(res)
        this.drawGenderDistribution(res.sex[0]);
        this.ageVal = 0;
        res.ages.forEach(el => {
          this.ageVal = this.ageVal + el;
        });
        this.drawPie(res.ages);
      });
      this.getLineData().then(data => {
        this.drawPolyline(data);
      });
    },

    // 获取并渲染新用户数据
    renderNewUserData() {
      this.getNewUserData().then(res => {
        this.drawGenderDistribution(res.sex[0]);
        this.ageVal = 0;
        res.ages.forEach(el => {
          this.ageVal = this.ageVal + el;
        });
        this.drawPie(res.ages);
      });
      this.getLineData().then(data => {
        this.drawPolyline(data);
      });
    },

    // 获取并渲染新增检测数据
    renderNewCheckData() {
      this.getCheckData().then(res => {
        this.drawGenderDistribution(res.sex[0]);
        this.drawPie2(res.types);
      });
      this.getLineData().then(data => {
        this.drawPolyline(data);
      });
    },

    // 获取并渲染新增检测数据
    renderReportViewData() {
      this.getReportView().then(res => {
        this.drawBar(res.reports);
      });
      this.getLineData().then(data => {
        this.drawPolyline(data);
      });
    },

    // 格式化性别数据
    formatSex(_data) {
      if (_data && _data.length === 2 && !(!_data[0] && !_data[1])) {
        const data = _data.map(v => Math.round(parseFloat(v) * 100));

        this.male = data[0];
        this.female = data[1];

        return [this.male, this.female];
      }
      this.male = 0;
      this.female = 0;
      return [this.male, this.female];
    },

    // 格式化年龄数据
    formatAges(data) {
      return data.map(v => parseFloat(v) * 100);
    },

    // 获取用户数据
    getUserData() {
      return DashboardService.getUserDatas().then(res => {
        const data = res.data.data;
        const sex = this.formatSex(data.info.sex);
        const ages = this.formatAges(data.info.age);

        this.userTotal = {
          today: data.today_all_num,
          yesterday: data.yesterday_all_num,
          sex,
          ages
        };

        return Promise.resolve(this.userTotal);
      });
    },

    // 获取新用户数据
    getNewUserData() {
      return DashboardService.getNewUserDatas().then(res => {
        const data = res.data.data;
        const sex = this.formatSex(data.info.sex);
        const ages = this.formatAges(data.info.age);

        this.newUserTotal = {
          today: data.today_num,
          yesterday: data.yesterday_num,
          sex,
          ages
        };

        return Promise.resolve(this.newUserTotal);
      });
    },

    // 获取检测数据
    getCheckData() {
      return DashboardService.getCheckDatas().then(res => {
        const data = res.data.data;
        const sex = this.formatSex(data.info.sex);

        this.newCheckTotal = {
          today: data.today_num,
          yesterday: data.yesterday_num,
          types: data.info.type,
          sex
        };

        return Promise.resolve(this.newCheckTotal);
      });
    },

    // 获取报告查看数据
    getReportView() {
      return DashboardService.getReportDatas().then(res => {
        const data = res.data.data;
        this.viewReportTotal = {
          today: data.today_num,
          yesterday: data.yesterday_num,
          reports: res.data.data.info
        };

        return Promise.resolve(this.viewReportTotal);
      });
    },

    // 获取折线图数据（自动根据当前 tab 计算请求）
    getLineData() {
      const day = this.currentDays;
      const currentActived = this.actived;
      const funcName = [
        "",
        "getUserTotalByLine",
        "getNewUserTotalByLine",
        "getCheckTotalByLine",
        "getReportTotalByLine"
      ][currentActived];

      return DashboardService[funcName](day).then(res => {
        const currentData = res.data.data.info.reverse();
        const date = currentData.map(v => v.d);
        const values = currentData.map(v => v.num);

        return Promise.resolve({
          date,
          values
        });
      });
    },

    // 绘制饼图（用户数据/新用户数据）
    drawPie(values) {
        if (![1, 2].includes(this.actived)) return;

        const names = ["19岁及以下", "20-29岁", "30-39岁", "40-49岁", "50岁以上"];
        const data = [];
        for (let i = 0; i < names.length; i++) {
            const name = names[i];
            const value = values[i];
            data.push({
            value,
            name: `${name}：${parseFloat(value).toFixed(2)}%`
            });
        }

        this.$nextTick(() => {
            GraphService.drawPieGraph(document.getElementById("pie"), data);
        });
    },

    // 绘制第二种饼图（检测总数）
    drawPie2(types) {
        if (this.actived !== 3) return;
        const names = [
            "血压",
            "血糖",
            "血氧",
            "血尿酸",
            "血脂",
            "BMI",
            "体脂",
            "运动步数",
            "睡眠"
        ];
        const data = [];
        for (let i  = 0; i <  types.length; i ++) {
            data.push({
            name: types[i].type,
            value: types[i].num || 0
            });
        }
        this.$nextTick(() => {
                GraphService.drawPieGraph2(document.getElementById("pie"), data);
        });
    },

    // 绘制性别分布图（通用）
    drawGenderDistribution(number) {
      if (this.interval) clearInterval(this.interval);
      this.male = 0;

      // 数值自增动画
      this.interval = setInterval(() => {
        if (this.male >= number) {
            this.female = 100 - this.male
          return clearInterval(this.interval);
        }
        this.male += 1;
      }, 15);
    },

    // 绘制报告查看次数直方图
    drawBar(data) {
        if (this.actived !== 4) return;

        const hours = ["22点~0点 ", "18点~22点 ", "14点~18点 ", "10点~14点 ", "6点~10点 ", "0点~6点 ",];
        const male = [];
        const female = [];

        for (let [i, len] = [0, hours.length]; i < len; i += 1) {
            male.push(data[i].man);
            female.push(data[i].woman);
        }

        this.$nextTick(() => {
            GraphService.drawBarGraph(document.getElementById("bar"), {
                hours,
                value: [male, female]
            });
        });
    },

    // 绘制折线图（通用）
    drawPolyline(data) {
      GraphService.drawPolylineGraph(document.getElementById("polyline"), data);
    }
  },
  created() {
    //判断是否修改过密码（第一次登录必须修改初始密码）
    if(localStorage.getItem('flag') === '0'){
        this.$router.push("/editinitpwd")
    }
  },
  mounted() {
    this.actived = 1;
    // 当日日期-调列表
    let nowDate = new Date()
    let yesData = new Date(new Date().getTime() - 24 * 60 * 60 * 1000)   // 昨天
    
    this.today = nowDate.getFullYear()+'-'+((nowDate.getMonth() + 1) < 10 ? '0'+(nowDate.getMonth() + 1):(nowDate.getMonth() + 1))+'-'+(nowDate.getDate() < 10 ? '0'+nowDate.getDate():nowDate.getDate()) 
    this.yesterday = yesData.getFullYear()+'-'+((yesData.getMonth() + 1) < 10 ? '0'+(yesData.getMonth() + 1):(yesData.getMonth() + 1))+'-'+(yesData.getDate() < 10 ? '0'+yesData.getDate():yesData.getDate()) 
    // 默认渲染用户数据
    this.renderUserData();
    this.getNewUserData();
    this.getCheckData();
    this.getReportView();
  }
};
</script>
<style lang="scss" scoped>
$primary: #00bcff;
$currentBlue: #6fd6ff;
$currentRed: #ff7d97;
.blue {
  color: $currentBlue;
}
.red {
  color: $currentRed;
}
.main {
  padding: 10px;
  min-width: 1020px;
  background-color: #f1f2f7;
  .numerical,
  .graph,
  .polyline {
    margin-bottom: 10px;
    padding-top: 20px;
    padding-bottom: 15px;
    background-color: $white;
    box-shadow: 0px 3px 6px rgba(38, 153, 251, 0.1);
    border-radius: 4px;
    &:last-of-type {
      margin-bottom: 0;
    }
  }
  .numerical {
    padding: 0;
    height: 142px;
  }
  .big-screen{
    display: flex;
    height: 142px;
    width: 100px;
    justify-content: center;
    align-items: center;
    .big-screen-content{
        cursor: pointer;
        display: flex;
        flex-direction: column;
        align-items: center;
        background: #f3fafa;
        color: #00c6ae;
        border-radius: 5px;
        padding: 10px 15px;
        .bs-icon{
            width: 48px;
            height: 48px;
            margin-bottom: 5px;
        }
    }
  }
  .graph {
    height: 240px;
  }
  .polyline {
    height: 250px;
  }
}
.numerical {
  display: flex;
  &-column {
    margin: 0 30px;
    padding: 12px 0 20px 0;
    text-align: center;
    border-top: 4px solid transparent;
    flex: 1;
    cursor: pointer;
    user-select: none;
    transition: 0.5s all;
    &.actived {
      border-top-color: $primary;
      & > span {
        color: $primary;
      }
    }
    &:first-of-type {
      max-width: 100px;
      text-align: right;
      cursor: default;
      .title,
      .today,
      .yesterday {
        font-size: 14px;
        font-weight: normal;
      }
    }
    .title,
    .today,
    .yesterday {
      display: block;
    }
    .title {
      font-size: 18px;
      line-height: 25px;
    }
    .today {
      margin: 7px 0 10px 0;
      font-weight: bold;
      font-weight: 600;
      font-size: 30px;
      line-height: 42px;
    }
    .yesterday {
      color: $small-text-color;
      font-weight: bold;
      font-weight: 600;
      font-size: 16px;
      line-height: 22px;
    }
  }
}
.graph {
  .title {
    font-size: 14px;
    font-weight: bold;
    line-height: 20px;
    display: flex;
    & > span {
      text-align: center;
      flex: 1;
    }
  }
  .content {
    height: 185px;
    display: flex;
    & > div {
      flex: 1;
    }
  }
  .dotted {
    display: flex;
    justify-content: center;
    align-items: center;
    .icon {
      margin: 0 7px;
      font-size: 72px;
      display: inline-block;
    }
    &-content {
      width: calc((10px + 6px) * 20);
      /deep/ .dotted-title {
        text-align: center;
        color: $small-text-color;
      }
      /deep/ .title {
        display: flex;
        justify-content: space-between;
        font-size: 36px;
        line-height: 50px;
        .blue {
          color: $currentBlue;
        }
        .red {
          color: $currentRed;
        }
      }
    }
  }
  /deep/ .dots {
    width: 100%;
    height: calc((10px + 6px) * 5);
    display: inline-flex;
    flex-wrap: wrap;
    flex-direction: column;
    overflow: hidden;
    .dot {
      margin: 3px;
      width: 10px;
      height: 10px;
      border-radius: 100%;
      display: inline-block;
      transition: 0.1s background ease-in-out;
      &.male {
        background-color: $currentBlue;
      }
      &.female {
        background-color: $currentRed;
      }
    }
  }
}
.polyline {
  padding: 20px;
  &-hd {
    height: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &-title {
    font-size: 14px;
    font-weight: bold;
    font-weight: 600;
    line-height: 30px;
  }
  &-subtitle {
    font-size: 12px;
    color: $small-text-color;
  }
  #polyline {
    height: 185px;
  }
}
.no-dots {
  text-align: center;
  height: 80px;
  line-height: 80px;
}
.initPwdDialog {
  text-align: center;
  margin: 20px;
  .el-button {
    width: 100px;
  }
}
@keyframes mymove {
  from {
    left: 0px;
  }
  to {
    left: 200px;
  }
}
</style>
